import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import moment from 'moment';
import { MatInput } from '@angular/material/input';
import { FormControl, FormGroup } from '@angular/forms';
import { SetDateStringService } from '@providers/set-date-string/set-date-string';

type Action = string | number | MatInput;

@Component({
    selector: 'app-calendar',
    templateUrl: './calendar.html',
    standalone: false
})
export class CalendarComponent implements OnInit {
  @Input() classDiv: string = '';
  @Input() idCalendar: string = '';
  @Input() placeholder: string = '';
  @Input() max: Date;
  @Input() min: Date;
  @Input() modelData: string = '';
  @Input() days: number[];

  @Input() newCalendar: boolean;
  @Input() picker: FormControl;
  @Input() rangeCalendar: boolean;
  @Input() range: FormGroup;
  @Input() parentId: string = '';

  modelControl: Date;

  @Output() firstDateChange = new EventEmitter<any>();
  @Output() ClickAction = new EventEmitter<Record<string, Action>>();
  @Output() ClearAction = new EventEmitter<void>();
  @ViewChild('input', { read: MatInput }) input: MatInput;

  constructor(private formatDate: SetDateStringService) {}

  ngOnInit(): void {
    this.modelControl = moment(this.modelData, 'DD-MM-YYYY').toDate();
  }

  filterDate = (d: Date): boolean => {
    if (this.days) {
      const date = this.formatDate.setDateString(d, 1, '-');
      return (
        this.days.length === 0 ||
        !this.days.some(
          day => day === (!!Number(day) || day === 0 ? d.getDay() : date)
        )
      );
    } else return true;
  };

  // Evita que se cierre el calendario dentro de un menu
  markCalendarOverlayAsMenuChild(): void {
    if (!this.parentId) return;

    requestAnimationFrame(() => {
      const overlayPane = Array.from(document.querySelectorAll('.cdk-overlay-pane'))
        .find((pane) => pane.querySelector('.mat-datepicker-content, .mat-mdc-datepicker-content')) as HTMLElement | undefined;

      if (!overlayPane) return;

      overlayPane.setAttribute('data-ignore-click-outside-for', this.parentId);
      overlayPane.classList.add('calendar-menu-overlay-pane');

      const overlayContainer = overlayPane.closest('.cdk-overlay-container') as HTMLElement | null;
      overlayContainer?.classList.add('calendar-menu-overlay-container');

      overlayPane.addEventListener('click', this.stopCalendarClickPropagation);
    });
  }

  private stopCalendarClickPropagation = (event: Event): void => {
    event.stopPropagation();
  };

  removeCalendarOverlayMenuChild(): void {
    document.querySelectorAll('.calendar-menu-overlay-pane').forEach((overlayPane) => {
      overlayPane.removeEventListener('click', this.stopCalendarClickPropagation);
      overlayPane.classList.remove('calendar-menu-overlay-pane');
      overlayPane.removeAttribute('data-ignore-click-outside-for');
      const overlayContainer = overlayPane.closest('.cdk-overlay-container') as HTMLElement | null;
      overlayContainer?.classList.remove('calendar-menu-overlay-container');
    });
  }
  //----------------------------------------------------

  clickAction($event): void {
    const { value } = $event;
    this.modelControl = value;
    this.modelData = this.formatDate.setDateString(value, 1, '-');
    this.ClickAction.emit({ model: this.modelData, input: this.input });
  }

  clickFirstDate(): void {
    this.firstDateChange.emit();
  }

  clickRange(): void {
    if (this.range.value.end) {
      const { start, end } = this.range.value;
      this.ClickAction.emit({ start: start.getTime(), end: end.getTime() });
    } else {
      this.firstDateChange.emit();
    }
  }

  clickRangeClear(): void {
    this.range.controls.start.setValue('');
    this.range.controls.end.setValue('');
    this.ClearAction.emit();
  }

  clickCalendar(): void {
    this.ClickAction.emit();
  }
}
